import type {
  Configuration,
  Configuration3dBody,
  Configuration3d,
  OptionsBody,
  UserConfigurationBody,
  UserConfigurationSlug,
  UserConfiguration,
  UserConfigurationDetails,
  AccessoriesChangeBody,
  AccessoriesChange,
} from '~/types/configurator'

export function createConfiguratorRepository() {
  const { $api } = useNuxtApp()
  const { get, post } = baseRepository($api)

  const DOMAIN = 'product-configurator'

  async function getPreConfigured(
    productNid: number,
    params: {
      language: string
      configurationNid?: number
      customerGroupNid?: number
      priceCategoryNid?: number
    }
  ) {
    return get<Configuration>(
      [DOMAIN, productNid.toString(), 'preconfigured'],
      { params }
    )
  }

  async function getOptions(
    body: OptionsBody,
    params: {
      productNid: number
      language: string
      customerGroupNid?: number
      priceCategoryNid?: number
    }
  ) {
    return post<Configuration>([DOMAIN, 'options'], {
      body,
      params,
    })
  }

  async function getConfiguration3d(
    body: Configuration3dBody,
    productNid: number
  ) {
    return post<Configuration3d>([DOMAIN, '3d-configuration'], {
      body,
      params: {
        productNid,
      },
    })
  }

  async function getUserConfigurationSlug(body: UserConfigurationBody) {
    return post<UserConfigurationSlug>([DOMAIN, 'user-configurations'], {
      body,
    })
  }

  async function getUserConfigurationBySlug(
    slug: string,
    params: {
      language?: string
      customerGroupNid?: number
      priceCategoryNid?: number
    }
  ) {
    return get<UserConfiguration>([DOMAIN, 'user-configurations', slug], {
      params,
    })
  }

  async function getUserConfigurationDetailsBySlug(
    slug: string,
    params: {
      customerGroupNid?: number
      priceCategoryNid?: number
    }
  ) {
    return get<UserConfigurationDetails>(
      [DOMAIN, 'user-configurations', 'details', slug],
      {
        params,
      }
    )
  }

  async function getAccessoryChange(
    body: AccessoriesChangeBody,
    params: {
      productNid: number
      language: string
    }
  ) {
    return post<AccessoriesChange>([DOMAIN, 'accessories'], {
      body,
      params,
    })
  }

  return {
    getPreConfigured,
    getOptions,
    getConfiguration3d,
    getUserConfigurationSlug,
    getUserConfigurationBySlug,
    getUserConfigurationDetailsBySlug,
    getAccessoryChange,
  }
}
